module.exports = __webpack_public_path__ + "static/media/11_rin55c3fa9ca4aa535f5b1ab4cc0ab8d4e3.webp";